import highlight from './highlight';
import refractor from 'refractor/core';
var SyntaxHighlighter = highlight(refractor, {});

SyntaxHighlighter.registerLanguage = function (_, language) {
  return refractor.register(language);
};

export default SyntaxHighlighter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-syntax-highlighter/dist/esm/prism-light.js
// module id = 422
// module chunks = 0